{
  "role": {
    "sales_agent": "Sales agent",
    "sales_admin": "Sales administrator",
    "main": "Standard",
    "limited": "Limited"
  },
  "sales_agent": "{count, plural, =0 {no sales agents} =1 {1 sales agent} other {# sales agents}}"
}
